const footerRu = {
  'footer': {
    'aboutMobile': 'Для установки мобильного приложения наведите камеру телефона на QR-код',
    'aboutPhone': 'Бесплатно по РФ',
    'aboutUniCredit': 'Enter.UniCredit — интернет-банк Энтер.ЮниКредит, Mobile.UniCredit — мобильное приложение Мобайл.ЮниКредит',
    'aboutLicense': 'АО ЮниКредит Банк, Генеральная лицензия №1 Банка России',
  },
};

export default footerRu;
